import { statusBadgeTones } from '@/components/StatusBadge';

export const LEAVE_TYPE_FILTER_OPTIONS = [
  { value: null, label: 'All Types' },
  { value: 'Planned Leave', label: 'Planned Leave' },
  { value: 'Sick Leave', label: 'Sick Leave' },
  { value: 'Casual Leave', label: 'Casual Leave' },
  { value: 'Unpaid Leave', label: 'Unpaid Leave' },
];

export const LEAVE_TYPE_TONE = {
  'Planned Leave': statusBadgeTones.info,
  'Sick Leave': statusBadgeTones.error,
  'Casual Leave': statusBadgeTones.warning,
  'Unpaid Leave': statusBadgeTones.default,
};

export const LEAVE_STATUS_FILTER_OPTIONS = [
  { value: null, label: 'All Status' },
  { value: 'Approved', label: 'Approved' },
  { value: 'Pending', label: 'Pending' },
  { value: 'Rejected', label: 'Rejected' },
];

export const LEAVE_STATUS_TONE = {
  Approved: statusBadgeTones.success,
  Pending: statusBadgeTones.warning,
  Rejected: statusBadgeTones.error,
};

// leaveDate is stored as an unpadded "YYYY-M-D" string (see LeaveFormModal) —
// parsed locally (not via Date's own string parser, which is inconsistent
// about non-padded/dash-separated formats across engines).
export function parseLeaveDateString(str) {
  if (!str) return null;
  const [year, month, day] = str.split('-').map(Number);
  if (!year || !month || !day) return null;
  return new Date(year, month - 1, day);
}
